import { create } from 'zustand';
import useDataStore from './useDataStore';
import dayjs from 'dayjs';
import 'dayjs/locale/nl';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
const useTestData = false;
const useWidgetStore = create()((set) => {
    var _a;
    return ({
        booking: useTestData ? {
            appointments: [
                {
                    components: [
                        {
                            time: new Date('2026-07-08 14:00'),
                            appointmentTypes: [304],
                            resources: [189],
                            capacity: 1
                        }
                    ],
                    date: new Date('2026-07-08 14:00'),
                    price: 15.85
                },
                {
                    components: [
                        {
                            time: new Date('2026-07-09 15:00'),
                            appointmentTypes: [304],
                            resources: [189],
                            capacity: 1
                        }
                    ],
                    date: new Date('2026-07-09 15:00'),
                    price: 15.85
                }
            ]
        } : {},
        //@ts-ignore
        consumer: useTestData ? {
            // "id": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjMxMzgyfQ.aUL-Lo7QudOshJi4v2066xUXxdDicdvYO3JcaJNo4-o",
            "id": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjMwOTI1fQ.5JqPmH48wUQkJyXOlUH5JU4Im6vIvM7H7AZ8qOD9Mqc",
            // "hash": "agHacja026ZHlootef1a1ckb7b2kbjYH",
            "hash": "b1ck9roedp0ddfnZnk562pj8m9tm7b49",
            firstName: 'Britanny',
            lastName: 'Boem',
            email: `ricardo.matters+${Math.floor(Math.random() * 10000)}@gmail.com`,
            phone: '0612345678',
            contracts: [
                'acceptTerms',
                'acceptPrivacy'
            ],
            business: {
                name: 'Mizar',
                city: 'Den Haag'
            },
            type: 'business',
            fields: {
                "custom-field-2071027": "chriet1",
                "custom-field-2071028": "",
                "custom-field-2071046": 3,
                "custom-field-2071063": "3r4thertyj45tyj"
            },
            mandate: useTestData ?
                // {
                //     id: 92,
                //     status: "enabled",
                //     holder: "H. R. Matters",
                //     iban: "NL**RABO***173",
                //     signatureDate: "2026-03-05",
                //     // membershipTypes: []
                //     membershipTypes: [55]
                // } as Mandate : 
                undefined :
                undefined
        } : {},
        cart: {
            giftCards: [],
            discounts: [],
            lines: useTestData ? [
                {
                    name: "Brazilian Crush Cheirosa 62 Mist",
                    price: 39.00,
                    quantity: 1,
                    productId: 3657,
                    productType: "product",
                    origin: "optionalPurchase"
                },
                {
                    name: "Bier - S",
                    price: 2.5,
                    quantity: 2,
                    productId: 3647,
                    productType: "product",
                    origin: "optionalPurchase"
                },
                {
                    name: "Verzendkosten",
                    price: 3.95,
                    quantity: 1,
                    productId: 3682,
                    productType: "product",
                    origin: "requiredPurchase",
                    requiredBy: "appointment"
                },
                {
                    name: "Inpakpapier",
                    price: 2,
                    quantity: 1,
                    productId: 3683,
                    productType: "product",
                    origin: "requiredPurchase",
                    requiredBy: 3657
                }
            ] : [],
            mutators: [],
            transactions: useTestData ? [
            // {
            //     id: 'IQpzICWp4xciERbsG8e6O2dLJeg-mwRC8RjWqd20yok33489',
            //     transactionId: 'c_V24kuILY7QxkQH3yx4TNB-6LfRMZFcdPMuLBIL0qo3071',
            //     status: 'pending'
            // } as Transaction
            ] : [],
            payments: [],
            mandatables: useTestData ? [
            // {
            //     id: 55,
            //     balance: 0,
            //     buyable: true,
            //     image: "/modules/consumer/images/subscriptionType.png",
            //     initialFee: 5.43,
            //     intervals: 1,
            //     mandatable: true,
            //     membershipRequired: "optional",
            //     price: 19.99,
            //     product_id: 3414,
            //     required: "optional",
            //     sellPrice: 240,
            //     subscriptionId: undefined,
            //     title: "Asocialo",
            //     type: "membership",
            //     validDuration: "2 year",
            //     max: 0,
            //     charge: 0,
            //     infiniteCredits: false,
            //     endDate: false
            // }
            ] : [],
            /* useTestData ? [
                {
                    id: 63,
                    balance: 0,
                    buyable: true,
                    image: "/modules/consumer/images/subscriptionType.png",
                    initialFee: 10,
                    intervals: 1,
                    mandatable: true,
                    membershipRequired: "optional",
                    price: 10,
                    product_id: 3625,
                    required: "optional",
                    sellPrice: 120,
                    title: "SuperDuper Jaar",
                    type: "membership",
                    validDuration: "2 year",
                    max: 0,
                    charge: 0,
                    infiniteCredits: false,
                    endDate: false
                }
            ] : [],*/
            // currentPayment: useTestData ? {
            // id: 'cWBlwCyoWNhGEJ_fhT_eWQoNSb_G8ZU4lggnfaUSjqY1751'
            //  } as Payment : {} as Payment
        },
        language: (_a = localStorage.getItem('oaLanguage')) !== null && _a !== void 0 ? _a : 'nl',
        hasBooking: useTestData ? true : false,
        hasProduct: false,
        isAccount: useTestData ? true : false,
        isDirtyAccount: useTestData ? false : true,
        isGuest: useTestData ? false : true,
        isLoginAccount: useTestData ? true : false,
        isNewAccount: false,
        selectedGroup: [],
        selectedApptype: useTestData ? [304] : [],
        selectedResource: useTestData ? [189] : [],
        selectedCategory: [],
        selectedProduct: [],
        selectedDate: useTestData ? [new Date('2026-06-23 14:00')] : [],
        selectedTime: [],
        selectedCapacity: useTestData ? 1 : 1,
        // @ts-ignore
        selectedCapacityGroups: useTestData ? { 0: 1 } : { 0: 1 }, //{ 50: 2, 51: 0 } : { 0: 1 },
        setIsAccount: (isAccount) => set(() => ({ isAccount: isAccount })),
        setIsGuest: (isGuest) => set(() => ({ isGuest: isGuest })),
        setIsLoginAccount: (isLoginAccount) => set(() => ({ isLoginAccount: isLoginAccount })),
        setIsDirtyAccount: (isDirtyAccount) => set(() => ({ isDirtyAccount: isDirtyAccount })),
        setIsNewAccount: (isNewAccount) => set(() => ({ isNewAccount: isNewAccount })),
        setSelectedDate: (date) => set(() => ({ selectedDate: date ? [date] : [] })),
        setSelectedTime: (time) => set(() => ({ selectedTime: time ? [time] : [] })),
        setSelectedGroup: (id) => set(() => ({ selectedGroup: id ? [id] : [] })),
        setSelectedGroups: (ids) => set(() => ({ selectedGroup: ids ? ids : [] })),
        setSelectedApptype: (id) => set(() => ({ selectedApptype: id ? [id] : [] })),
        setSelectedApptypes: (ids) => set(() => ({ selectedApptype: ids ? ids : [] })),
        setSelectedResource: (id) => set(() => ({ selectedResource: id ? [id] : [] })),
        setSelectedResources: (ids) => set(() => ({ selectedResource: ids ? ids : [] })),
        setSelectedCategory: (id) => set(() => ({ selectedCategory: id ? [id] : [] })),
        setSelectedCategories: (ids) => set(() => ({ selectedCategory: ids ? ids : [] })),
        setSelectedProduct: (id) => set(() => ({ selectedProduct: id ? [id] : [] })),
        setSelectedProducts: (ids) => set(() => ({ selectedProduct: ids ? ids : [] })),
        setSelectedCapacity: (amount) => set(() => ({ selectedCapacity: amount })),
        setSelectedCapacityGroups: (capacities) => set(() => ({ selectedCapacityGroups: capacities })),
        setBooking: (booking) => set(() => ({ booking: booking, hasBooking: booking !== undefined })),
        setConsumer: (consumer) => set(() => ({ consumer: consumer !== null && consumer !== void 0 ? consumer : {} })),
        setCart: (cart) => set(() => ({ cart: cart })),
        setLanguage: (language) => {
            localStorage.setItem('oaLanguage', language);
            set(() => ({ language: language }));
        },
        resetBooking: () => {
            let state = useWidgetStore.getState();
            state.setBooking();
        },
        resetCart: () => {
            let state = useWidgetStore.getState();
            state.setCart({
                discounts: [],
                giftCards: [],
                lines: [],
                mutators: [],
                transactions: [],
                mandatables: [],
                payments: [],
                currentPayment: undefined
            });
        },
        resetConsumer: () => {
            let state = useWidgetStore.getState();
            state.setConsumer();
        },
        enabled: {
            apptype: false,
            resource: false,
            group: false,
            category: false,
            product: false,
            date: false,
            time: false
        },
        setEnabled: (enabled) => set(() => ({ enabled: enabled })),
        paymentMethods: [],
        setPaymentMethods: (paymentMethods) => set(() => ({ paymentMethods: paymentMethods ? paymentMethods : [] })),
        paymentOptions: {},
        setPaymentOptions: (paymentOptions) => set(() => ({ paymentOptions: paymentOptions ? paymentOptions : {} })),
        fees: [],
        setFees: (fees) => set(() => ({ fees: fees ? fees : [] })),
        isPaying: false,
        setIsPaying: (isPaying) => set(() => ({ isPaying: isPaying ? isPaying : false })),
        getSourceHelpers: (source) => {
            let state = useWidgetStore.getState(), dataState = useDataStore.getState();
            let type = state.selectedApptype, options = dataState.apptypes, setter = state.setSelectedApptype, setterMulti = state.setSelectedApptypes;
            switch (source) {
                case 'apptype':
                    type = state.selectedApptype;
                    options = dataState.apptypes;
                    setter = state.setSelectedApptype;
                    setterMulti = state.setSelectedApptypes;
                    break;
                case 'category':
                    type = state.selectedCategory;
                    options = dataState.categories;
                    setter = state.setSelectedCategory;
                    setterMulti = state.setSelectedCategories;
                    break;
                case 'group':
                    type = state.selectedGroup;
                    options = dataState.groups;
                    setter = state.setSelectedGroup;
                    setterMulti = state.setSelectedGroups;
                    break;
                case 'product':
                    type = state.selectedProduct;
                    options = dataState.products;
                    setter = state.setSelectedProduct;
                    setterMulti = state.setSelectedProducts;
                    break;
                case 'resource':
                    type = state.selectedResource;
                    options = dataState.resources;
                    setter = state.setSelectedResource;
                    setterMulti = state.setSelectedResources;
                    break;
            }
            return {
                type: type !== null && type !== void 0 ? type : [],
                options: options,
                setter: setter,
                setterMulti: setterMulti
            };
        },
        getDaoProducts: () => {
            let state = useWidgetStore.getState(), dataState = useDataStore.getState();
            let _products = [];
            state.cart.lines.map((line) => {
                if (line.productType !== "appointment") {
                    _products.push({
                        product_id: line.productId,
                        type: line.productType,
                        origin: line.origin,
                        title: line.name,
                        amount: line.quantity,
                        price: line.price
                    });
                }
            });
            return _products;
        },
        // @deprecatd
        getGeneratedDaoProducts: () => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
            let state = useWidgetStore.getState(), dataState = useDataStore.getState();
            let _products = [];
            // this is all handled in the API now
            // we should not generate the products in the widget anymore
            // however, I have reenabled this for now to be used by the useVouchers API call ( not ported )
            // because I keep porting different things now and it's getting a bit much no
            if (state.booking && dataState.apptypes && ((_b = (_a = state.booking) === null || _a === void 0 ? void 0 : _a.appointments) !== null && _b !== void 0 ? _b : []).length > 0) {
                let appointment = state.booking.appointments[0];
                if (appointment) {
                    let dateStr = dayjs(appointment.date).locale(state.language).format('YYYY-MM-DD'), timeStr = dayjs(appointment.date).locale(state.language).format('HH:mm');
                    let apptypeId = (_e = (_d = (_c = state.booking) === null || _c === void 0 ? void 0 : _c.appointments[0]) === null || _d === void 0 ? void 0 : _d.components[0]) === null || _e === void 0 ? void 0 : _e.appointmentTypes[0];
                    let apptype = dataState.apptypes.find((apptype) => apptype.id === apptypeId);
                    let resourceId = ((_h = (_g = (_f = state.booking) === null || _f === void 0 ? void 0 : _f.appointments[0]) === null || _g === void 0 ? void 0 : _g.components[0]) === null || _h === void 0 ? void 0 : _h.resources.length) > 0 ?
                        (_l = (_k = (_j = state.booking) === null || _j === void 0 ? void 0 : _j.appointments[0]) === null || _k === void 0 ? void 0 : _k.components[0]) === null || _l === void 0 ? void 0 : _l.resources.join(',') : '-1';
                    if (apptype) {
                        _products.push({
                            type: "appointment",
                            origin: "appointment",
                            title: apptype.name,
                            desciption: "", // has typo
                            // price: 15.85, // old widget posts correct value
                            // depositPrice: 7.5, //null, // old widget posts correct value
                            specialPrice: null,
                            amount: 1,
                            appointment: {
                                date: dateStr,
                                time: timeStr,
                                appTypeId: (_p = (_o = (_m = state.booking) === null || _m === void 0 ? void 0 : _m.appointments[0]) === null || _o === void 0 ? void 0 : _o.components[0]) === null || _p === void 0 ? void 0 : _p.appointmentTypes, // expects an array
                                // @ts-ignore
                                resourceId: resourceId, // expects a string
                                resourceCount: (_s = (_r = (_q = state.booking) === null || _q === void 0 ? void 0 : _q.appointments[0]) === null || _r === void 0 ? void 0 : _r.components[0]) === null || _s === void 0 ? void 0 : _s.resources.length,
                                duration: apptype.duration,
                                capacity: state.selectedCapacity,
                                capacities: state.selectedCapacityGroups,
                                price: {
                                // 304:  15.85 //apptype?.price // old widget posts correct value
                                },
                                fields: {}, // not the same as in appointments, its empty on the product
                                components: null // old widget does this
                            },
                            subscriptionRequired: false,
                            subscriptionAvailable: false,
                            subscription: null, //{},// old widget does this
                            subscriptionBuyable: false,
                            subscriptionBuy: null,
                            membershipRequired: false,
                            membershipAvailable: false,
                            membership: null, // {},// old widget does this
                            membershipBuyable: false,
                            membershipBuy: null,
                            mandate: null,
                            extraInfo: {},
                            // mandateAccountname: "",
                            // mandateAccountno: "",
                        });
                    }
                }
            }
            return _products;
        },
        getDaoAppointments: () => {
            var _a, _b, _c, _d, _e;
            let state = useWidgetStore.getState(), dataState = useDataStore.getState();
            let _appointments = [];
            if (state.booking && dataState.apptypes && ((_b = (_a = state.booking) === null || _a === void 0 ? void 0 : _a.appointments) !== null && _b !== void 0 ? _b : []).length > 0) {
                let appointment = state.booking.appointments[0];
                if (appointment) {
                    let apptypeId = (_c = appointment.components[0]) === null || _c === void 0 ? void 0 : _c.appointmentTypes[0];
                    let apptype = dataState.apptypes.find((apptype) => apptype.id === apptypeId);
                    if (apptype) {
                        let hasSelectedResource = state.selectedResource ? state.selectedResource.filter((resourceId) => resourceId !== -1).length > 0 : false;
                        let resourceId = ((_d = appointment.components[0]) === null || _d === void 0 ? void 0 : _d.resources.length) > 0 && hasSelectedResource ?
                            (_e = appointment.components[0]) === null || _e === void 0 ? void 0 : _e.resources : [-1];
                        state.booking.appointments.map((_appointment) => {
                            var _a;
                            let dateStr = dayjs(_appointment.date).locale(state.language).format('YYYY-MM-DD'), timeStr = dayjs(_appointment.date).locale(state.language).format('HH:mm');
                            _appointments.push({
                                appTypeId: (_a = appointment.components[0]) === null || _a === void 0 ? void 0 : _a.appointmentTypes, // expects an array
                                resourceId: resourceId, // expects an array
                                date: dateStr,
                                time: timeStr,
                                capacity: state.selectedCapacity,
                                capacities: state.selectedCapacityGroups,
                            });
                        });
                    }
                }
            }
            /*
     let _appointments: AppointmentComponentDao[] = []
    
            if (state.booking && dataState.apptypes && (state.booking?.appointments ?? []).length > 0) {
                let appointment: Appointment = state.booking.appointments[0]
    
                if (appointment) {
                    let dateStr: string = dayjs(appointment.date).locale(state.language).format('YYYY-MM-DD'),
                        timeStr: string = dayjs(appointment.date).locale(state.language).format('HH:mm')
    
                    let apptypeId = state.booking?.appointments[0]?.components[0]?.appointmentTypes[0]
                    let apptype = dataState.apptypes.find((apptype: DataType) => apptype.id === apptypeId)
                    let hasSelectedResource : boolean = state.selectedResource ? state.selectedResource.filter((resourceId) => resourceId !== -1).length > 0 : false
                    let resourceId = state.booking?.appointments[0]?.components[0]?.resources.length > 0 && hasSelectedResource ?
                        state.booking?.appointments[0]?.components[0]?.resources : [-1]
    
                    if (apptype) {
                        _appointments.push({
                            appTypeId: state.booking?.appointments[0]?.components[0]?.appointmentTypes, // expects an array
                            resourceId: resourceId, // expects an array
                            date: dateStr,
                            time: timeStr,
                            capacity: state.selectedCapacity,
                            capacities: state.selectedCapacityGroups,
                        })
                    }
                }
            }
            */
            return _appointments;
        },
        getDaoDiscounts: () => {
            var _a, _b;
            let state = useWidgetStore.getState();
            return (_b = (_a = state.cart) === null || _a === void 0 ? void 0 : _a.discounts) !== null && _b !== void 0 ? _b : [];
        },
    });
});
export default useWidgetStore;
